module.exports = __webpack_public_path__ + "static/media/d8.009bcd7b.png";